module.exports = __webpack_public_path__ + "static/media/favicon.1ad7a741.ico";